import { Injectable } from "@angular/core";
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { MainMenuComponent } from "@irb-common/modules/main-menu/main-menu.component";
import { AppService } from "@irb/app.service";
import { IrbEditorsEvents } from "@irb-common/events";

@Injectable({
  providedIn: "root",
})
export class IrbNavigationGuard  {
  constructor(private as: AppService, private router: Router) {}
  canDeactivate(component: MainMenuComponent, route: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) {
    const a = (component || route || currentState);

    if(MainMenuComponent.slotAEditorHasUnsavedChanges || MainMenuComponent.slotBEditorHasUnsavedChanges || MainMenuComponent.slotCEditorHasUnsavedChanges) {
      const f = (() => { this.router.navigate([nextState.url]); }).bind(this);
      
      if(MainMenuComponent.slotAEditorHasUnsavedChanges) {
        this.as.fireEvent(IrbEditorsEvents.CANCEL, { slot: "A", pendingFunction: f, source: "navigation"});
      }

      if(MainMenuComponent.slotBEditorHasUnsavedChanges) {
        this.as.fireEvent(IrbEditorsEvents.CANCEL, { slot: "B"});
      }

      if(MainMenuComponent.slotCEditorHasUnsavedChanges) {
        this.as.fireEvent(IrbEditorsEvents.CANCEL, { slot: "C"});
      }
    } else {
      this.as.fireEvent(IrbEditorsEvents.CLOSE_WITHOUT_SAVE, { slot: "A", source: "navigation"});
      this.as.fireEvent(IrbEditorsEvents.CLOSE_WITHOUT_SAVE, { slot: "B" });
      this.as.fireEvent(IrbEditorsEvents.CLOSE_WITHOUT_SAVE, { slot: "C" });
    }
    
    return !MainMenuComponent.slotAEditorHasUnsavedChanges && !MainMenuComponent.slotBEditorHasUnsavedChanges && !MainMenuComponent.slotCEditorHasUnsavedChanges;
  }
}
